import React from 'react';
import Timezone from '../Base';
import Styled from './style';

const Index = (props) => {
  return <Timezone {...props} Styled={Styled} />;
};

export default Index;
